export default {
  heading: "", // Заявки на публикацию
  selectEvent: "Choose an exhibition",
  selectEventPlaceholder: "All exhibition",
  searchPlaceholder: "Company search",

  takeToWork: "", // Взять в работу

  downloadDocx: "", // Сохранить файл в формате docx
  downloadAllImages: "", // Сохранить изображения в общем архиве
  downloadAll: "", // Скачать архив

  reasonLabel: "", // Причина отклонения
  linkLabel: "", // Причина отклонения

  publishRadioLabel: "", // Опубликовать
  rejectRadioLabel: "", // Отклонить

  tabFilter: {
    newTab: "New",
    workTab: "In work",
    rejectedTab: "Rejected",
    postedTab: "Posted"
  }
};
